export {default} from './ReportDataProvider.connect';
